import {
    BackButton,
    Divider,
    Form,
    FormDropDown,
    Header,
    setAttributeEntity,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileDwellingLossPayee = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Divider top={sizes.md} />
            <Header
                size={sizes.md}
                textAlign={alignments.left}
                text={<FormattedMessage id='Profile_Dwellings_LossPayee.lossPayee' />}
            />
            <Form
                label={<FormattedMessage id='Profile_Dwellings_LossPayee.lossPayeeDetails' />}
                allowEdit={props.allowEdit}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
            >
                <FormDropDown
                    label={<FormattedMessage id='Profile_Dwellings_LossPayee.name' />}
                    value={props.lossPayee}
                    references={props.reference.references?.HomeLossPayee}
                    referencesEvent={() => props.reference.doGetReferences('HomeLossPayee')}
                    changeEvent={(value) => setAttributeEntity(props.dotProp, value, props.doReducePolicyElement)}
                    allowEdit
                />
            </Form>
        </React.Fragment>
    );
};

export default ProfileDwellingLossPayee;
